import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useFormik} from "formik";
import {checkOtpCode, setToken} from "../../services";
import {initialValues, validationSchema} from "../../utils/formsValidator/checkOtpCodeFormValidator";
import {useAuthAction} from "../../context/AuthContext";
import {pushToast} from "../../utils/pushToast";
import Loading from "../../components/Loading";
import Input from "../../components/Input";

const OTP_EXPIRY_MS = 2 * 60 * 1000;

export default function OtpCode() {
    const navigate = useNavigate();
    const setAuth = useAuthAction();
    const mobile = sessionStorage.getItem('mobile');
    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(120);

    const clearOtpSession = () => {
        sessionStorage.removeItem('otpStartTime');
        sessionStorage.removeItem('mobile');
        localStorage.removeItem('authToken');
    };

    useEffect(() => {
        const startedAt = Number(sessionStorage.getItem('otpStartTime'));
        const authToken = localStorage.getItem('authToken');
        if (!startedAt || !authToken || !mobile) {
            clearOtpSession();
            navigate('/login', {replace: true});
            return;
        }

        const updateCountdown = () => {
            const remaining = Math.max(0, Math.ceil((OTP_EXPIRY_MS - (Date.now() - startedAt)) / 1000));
            setCountdown(remaining);
            if (remaining === 0) {
                clearOtpSession();
                navigate('/login', {replace: true});
            }
        };
        updateCountdown();
        const timer = setInterval(updateCountdown, 1000);
        return () => clearInterval(timer);
    }, [mobile, navigate]);

    const onSubmit = async (values) => {
        setIsLoading(true);
        try {
            const {userPermission, userInfo} = await checkOtpCode(values);
            if (userInfo?.isSuccess) {
                setToken(userInfo?.data?.token);
                setAuth({userInfo: userInfo?.data, userPermission});
                clearOtpSession();
                navigate('/dashboard');
            } else {
                pushToast("کد ورود اشتباه است.", "error");
            }
        } catch (error) {
            console.log(error);
            pushToast("کد ورود اشتباه است.", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const formik = useFormik({initialValues, validationSchema, onSubmit, validateOnChange: true});
    const formattedTime = `${String(Math.floor(countdown / 60)).padStart(2, '0')}:${String(countdown % 60).padStart(2, '0')}`;

    const backToLogin = () => {
        clearOtpSession();
        navigate('/login');
    };

    return (
        <div className="container-xxl">
            <div className="authentication-wrapper authentication-basic container-p-y">
                <div className="authentication-inner py-4">
                    <div className="card"><div className="card-body">
                        <div className="app-brand justify-content-center">
                            <img src="/logo.png" className="w-100" alt="Logo"/>
                        </div>
                        <h6 className="mb-2">کد ورود به شماره{' '}
                            <span className="border-bottom border-info text-info cursor-pointer" onClick={backToLogin}>{mobile}</span>{' '}
                            ارسال شد.</h6>
                        <form className={`needs-validation mb-3 ${!formik.isValid ? "was-validated" : ""}`}
                              noValidate onSubmit={formik.handleSubmit} autoComplete="off">
                            <div className="mb-3 position-relative">
                                <Input type="text" inputMode="numeric" className="text-start" dir="ltr" name="code"
                                       placeholder="کد ورود را وارد کنید" label="کد ورود" formik={formik}/>
                            </div>
                            <div className="mb-3 text-center text-danger">مدت اعتبار: {formattedTime}</div>
                            <button className="btn btn-primary d-grid w-100" type="submit" disabled={isLoading}>
                                اعتبارسنجی {isLoading && <Loading/>}
                            </button>
                        </form>
                    </div></div>
                </div>
            </div>
        </div>
    );
}
